import { Page, Spinner } from '@cint/wonderment';
import { ReactNode, Suspense } from 'react';

interface SuspenseWrapperProps {
  children: ReactNode;
}

export const SuspenseWrapper = ({ children }: SuspenseWrapperProps) => (
  <Suspense
    fallback={
      <Page
        style={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner size="xl" />
      </Page>
    }
  >
    {children}
  </Suspense>
);
